// @ts-nocheck
// Migration Safety Validator — Fase 15.9
export type MigrationRisk = 'safe' | 'low' | 'medium' | 'high' | 'critical'
export interface MigrationCheck { name: string; passed: boolean; risk: MigrationRisk; message: string }
export interface MigrationSafetyReport {
  timestamp: string; safeToMigrate: boolean; overallRisk: MigrationRisk
  checks: MigrationCheck[]; blockers: string[]; recommendations: string[]
}
export function validateMigrationSafety(): MigrationSafetyReport {
  const checks: MigrationCheck[] = []; const blockers: string[] = []; const recs: string[] = []
  const hasUrl = !!import.meta.env['VITE_SUPABASE_URL']
  checks.push({ name: 'supabase_url', passed: hasUrl, risk: hasUrl ? 'safe' : 'critical', message: hasUrl ? 'Supabase URL configured' : 'VITE_SUPABASE_URL missing' })
  if (!hasUrl) blockers.push('Supabase URL not configured')
  const version = (import.meta.env['VITE_APP_VERSION'] as string | undefined) ?? '0.0.0'
  const vOk = version !== '0.0.0'
  checks.push({ name: 'version_tagged', passed: vOk, risk: vOk ? 'safe' : 'low', message: vOk ? 'Version: ' + version : 'App version not set' })
  if (!vOk) recs.push('Set VITE_APP_VERSION before migration')
  const env = (import.meta.env['VITE_ENV'] as string | undefined) ?? 'development'
  checks.push({ name: 'not_production', passed: env !== 'production', risk: env === 'production' ? 'high' : 'safe', message: env === 'production' ? 'PRODUCTION — explicit approval required' : 'Environment: ' + env })
  if (env === 'production') recs.push('Test in staging before production')
  const lsOk = (() => { try { localStorage.setItem('_ms','1'); localStorage.removeItem('_ms'); return true } catch { return false } })()
  checks.push({ name: 'localstorage', passed: lsOk, risk: lsOk ? 'safe' : 'medium', message: lsOk ? 'localStorage accessible' : 'localStorage unavailable' })
  const critical = checks.some(c => c.risk === 'critical' && !c.passed)
  const worst = (['critical','high','medium','low','safe'] as MigrationRisk[]).find(r => checks.some(c => c.risk === r && !c.passed)) ?? 'safe'
  return { timestamp: new Date().toISOString(), safeToMigrate: !critical, overallRisk: worst, checks, blockers, recommendations: recs }
}
